<template>
    <el-tooltip :disabled="tooltipDisabled" :content="message" class="tsa-tooltipCustomV2" placement="top" :open-delay="200">
        <div @mouseenter="mouseenter"><slot /></div>
    </el-tooltip>
</template>

<script>
export default {
    data () {
        return {
			tooltipDisabled: false
		}
    },
    props: {
		message: {
			type: String,
			default: ''
		}
	},
    methods: {
        mouseenter(e) {
            setTimeout(() => {
                let el = e.target.firstElementChild
                let width = el.getBoundingClientRect().width;
                let contentWidth = this.getContentWidth(el);
                if (contentWidth > width) {
                    this.tooltipDisabled = false;
                }else{
                    this.tooltipDisabled = true
                }
            }, 200)
		},
		getContentWidth(el) {
			const range = new Range();
			range.selectNodeContents(el);
			const width = range.getBoundingClientRect().width;
			return width
		}
    },
}

</script>
<style scoped lang='scss'>
.tsa-tooltipCustomV2 {
    display:flex;
    align-items: center;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
</style>